"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
function isTaskFile(object) {
    return checkTaskFile(object).fulfilled;
}
exports.isTaskFile = isTaskFile;
function checkTaskFile(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return __1.check(object, __1.hasString("id"), __1.hasString("projectId"), __1.hasString("taskId"), __1.hasNumber("size").integer(), __1.hasChoice("type", ["IMAGE", "VIDEO", "AUDIO", "DOCUMENT", "FOLDER"]), __1.hasNumber("creationTimestamp").integer(), __1.hasNumber("lastModifiedTimestamp").integer(), __1.hasNumber("creatorId").optional(), __1.hasObject("meta", __1.hasArray("autoTags", __1.isString()).optional().nullable()).optional().nullable()).withOptions(options).explain();
}
exports.checkTaskFile = checkTaskFile;
//# sourceMappingURL=TaskFile.js.map